import { lt, showSuccessAlert } from '@mews/framework';
import { Payment as PaymentOldDto, WithAccountId } from '@mews-commander/types';
import { useRepositoryMutation } from '@mews-commander/data-access';
import { container } from '@mews-commander/legacy-app-instance';
import { setPayment } from '@mews-commander/legacy-entities/src/ducks/payments';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { useInvalidatePaymentsTableRecordsQueries } from '../../../../queries';
import { CashPaymentFormValues } from '../../ProcessPayment/CashPaymentForm/schema';
import { useInvalidateGetPaymentPlansTableRecords } from '../../../tables/PaymentPlans/queries';

// TODO: move to the correct folder
export const useCreateCashPayment = ({
    billId,
    accountId,
    onSubmitting,
    onSubmitted,
    onSuccess,
}: {
    billId: string | null;
    onSuccess?: () => void;
    onSubmitting?: () => void;
    onSubmitted?: () => void;
} & WithAccountId) => {
    const { appLocalizationComponent } = container();
    const dispatch = useCommanderThunkDispatch();
    const invalidatePaymentsTableRecordsQueries = useInvalidatePaymentsTableRecordsQueries();
    const invalidateGetPaymentPlansTableRecords = useInvalidateGetPaymentPlansTableRecords();

    const { localizeCurrencyValue } = appLocalizationComponent;

    return useRepositoryMutation('cashPayments', 'add', {
        transformParams: (formValues: CashPaymentFormValues) => ({
            ...formValues,
            billId,
            accountId,
        }),
        onSuccess: (payment, formValues) => {
            const { amount, currency } = payment;
            showSuccessAlert({
                description: lt('CashPaymentSuccessMessage', {
                    amount: localizeCurrencyValue({
                        value: amount,
                        currency,
                    }),
                }),
            });

            // compatibility for adding cash payment through billing tab
            dispatch(setPayment(payment as unknown as PaymentOldDto));

            invalidatePaymentsTableRecordsQueries({ accountId });
            invalidateGetPaymentPlansTableRecords(formValues.paymentPlanId);

            onSuccess?.();
        },
        onMutate: () => {
            onSubmitting?.();
        },
        onSettled: () => {
            onSubmitted?.();
        },
    });
};
